import { render, staticRenderFns } from "./editFeeDiscount.vue?vue&type=template&id=4522d2e8"
import script from "./editFeeDiscount.vue?vue&type=script&lang=js"
export * from "./editFeeDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports